import { render, staticRenderFns } from "./wf-radio-button-list-display.vue?vue&type=template&id=add40934&scoped=true&"
import script from "./wf-radio-button-list-display.vue?vue&type=script&lang=ts&"
export * from "./wf-radio-button-list-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-radio-button-list-display.vue?vue&type=style&index=0&id=add40934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add40934",
  null
  
)

export default component.exports